import React, { memo } from 'react';

import { Typography } from '@mui/material';

import {
	StyledLessonTimePlaceholderNumberBlock,
	StyledLessonTimePlaceholderNumberBlockWrap,
} from './styled';

interface PropsType {
	value: string | number;
	label: string;
}

function LessonTimePlaceholderNumberBlock({ value, label }: PropsType) {
	return (
		<StyledLessonTimePlaceholderNumberBlock>
			<StyledLessonTimePlaceholderNumberBlockWrap elevation={2}>
				<Typography variant="h2" sx={{ fontVariantNumeric: 'tabular-nums' }}>
					{value}
				</Typography>
			</StyledLessonTimePlaceholderNumberBlockWrap>
			<Typography variant="body2" color="#00000061">
				{label}
			</Typography>
		</StyledLessonTimePlaceholderNumberBlock>
	);
}

export default memo(LessonTimePlaceholderNumberBlock);
